import axios from 'axios';
import z from 'zod';

import { SERVICEBASEURL } from 'enums/serviceBaseUrls';
import { Optional } from 'functions/promiseExtensions';
import { createValidator } from 'functions/validation/zod';

// No PathParameters
// No QueryParameters

export const RequestBodySchema = z.object({
	fileIds: z.string().array(),
});
export type RequestBody = z.infer<typeof RequestBodySchema>;

const ResponseDataSchema = z.object({
	message: z.string(),
});
export type ResponseData = z.infer<typeof ResponseDataSchema>;
const validator = createValidator(ResponseDataSchema);

export async function callApi(input: {
	requestBody: RequestBody;
}): Promise<Optional<ResponseData>> {
	const url: string = SERVICEBASEURL.REPORT + `/v1/files/delete`;
	return (await axios.delete(url, { data: input.requestBody }).toOptionalFiltered(validator)).map((x) => x.data);
}
